import {Link as PrimerLink} from '@primer/react'
import {Link} from '@github-ui/react-core/link'
import {useClickAnalytics} from '@github-ui/use-analytics'
import {safeHref} from '../utils'

interface SidebarLinkProps {
  /** Internal route path (renders as client-side Link). */
  to?: string
  /** External or anchor URL (renders as plain href). */
  href?: string
  /** Analytics label suffix, e.g. 'section:stars' or 'file:readme'. Automatically prefixed with 'location:sidebar;'. */
  analyticsLabel?: string
  muted?: boolean
  inline?: boolean
  className?: string
  children: React.ReactNode
}

/** A link that automatically tracks clicks with sidebar analytics. */
export function SidebarLink({to, href, analyticsLabel, muted, inline, className, children}: SidebarLinkProps) {
  const {sendClickAnalyticsEvent} = useClickAnalytics()

  const handleClick = analyticsLabel
    ? () =>
        sendClickAnalyticsEvent({
          category: 'REPOSITORY_OVERVIEW',
          action: 'click',
          label: `location:sidebar;${analyticsLabel}`,
        })
    : undefined

  if (to) {
    return (
      <PrimerLink as={Link} to={to} muted={muted} inline={inline} className={className} onClick={handleClick}>
        {children}
      </PrimerLink>
    )
  }

  return (
    <PrimerLink href={safeHref(href)} muted={muted} inline={inline} className={className} onClick={handleClick}>
      {children}
    </PrimerLink>
  )
}
